import { Menu, MenuItem } from '@blueprintjs/core';
import * as React from 'react';

import { TEST_IDS } from 'src/constants/testIds';
import { useRemoveSelection } from 'src/containers/ProjectDiagram/hooks/remove/useRemoveSelection';
import * as copy from 'src/templates/copy';

export const MultiSelectionContextMenu: React.VFC = () => {
  const handleDeleteSelection = useRemoveSelection();

  return (
    <Menu>
      <MenuItem
        data-testid={TEST_IDS.projectDiagram.contextMenu.delete}
        onClick={handleDeleteSelection}
        text={copy.components.projectDiagram.contextMenu.deleteMultiple}
      />
    </Menu>
  );
};
